<template>
  <b-card>
    <p>Copy and paste from spreadsheet. <strong>Max 100 rows</strong> at a time.</p>
    <template v-slot:header>
      <span class="breadcrumbs"><b-link :to="{name: `image_template`}">Images</b-link> / Batch Create</span>
    </template>

    <div class="input-table">
      <hot-table :settings="table_settings" ref="data_table"></hot-table>
    </div>

    <p class='text-muted text-center'><small>As you add data more rows will appear</small></p>

    <LoadingButton :loading="loading" @click="create_batch">Add</LoadingButton>

  </b-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import ConstantsMixin from "@/mixins/Constants.js"
import { db, FieldValue, config } from '@/main.js'
import moment from 'moment/src/moment'

import api from '@/lib/api.js'

import { HotTable } from '@handsontable/vue'

export default {
  metaInfo: {title: 'Images batch create'},
  mixins: [ItemMixin, ConstantsMixin],
  props: ['image_template', 'profile'],
  components: {HotTable},
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  mounted() {
    if (this.$refs.data_table && this.$refs.data_table.hotInstance) {
      this.$refs.data_table.hotInstance.render()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'image_template' || to.name === 'image') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  data() {
    let headers = []
    let columns = []

    if (this.image_template.svg.match(/\{\{first_name\}\}/)) {
      headers.push('First Name')
      columns.push({})
    }

    if (this.image_template.svg.match(/\{\{website_image\}\}/) || this.image_template.svg.match(/\{\{logo_image\}\}/)) {
      headers.push('Website URL')
      columns.push({})
    }

    headers.push('Email')
    columns.push({})

    return {
      table_settings: {
        data: [],
        columns: columns,
        colHeaders: headers,
        // colHeaders: true,
        rowHeaders: true,
        minSpareRows: 10,
        maxRows: 100,
        width: '100%',
        stretchH: 'all',
        height: '100%',
        licenseKey: 'non-commercial-and-evaluation',
      },
      param: 'image',
      collection: 'image',
      data: [],
      loading: false,
    }
  },
  methods: {
    async create_batch() {
      this.loading = true
      let rows = this.$refs.data_table.hotInstance.getData()

      let items = []
      for (let row_i in rows) {
        let row = rows[row_i]
        let all_null = true
        for (let col of row) {
          if (col !== null && col.trim() !== '') {
            all_null = false
          }
        }

        if (all_null) {
          continue
        }

        let item = {
          updated: new Date(),
          created: new Date(),
          user: db.collection('user').doc(this.profile.id),
          team: db.collection('team').doc(this.profile.team.id),
          status: 'pending',
          image_url: null,
          error_message: null,
          first_name: null,
          website: null,
          email: null
        }

        let first_name = null
        for (let col in row) {
          let val = row[col]
          let key = this.table_settings.colHeaders[col]

          if (key === 'First Name') {
            if (!val) {
              this.$swal({title: 'Incomple replacement', text: "Please add a first name", icon: 'warning'})
              this.loading = false
              return
            }

            item.first_name = val
          }

          if (key === 'Website URL') {
            if (!val) {
              this.$swal({title: 'Incomple replacement', text: "Please add a website URL", icon: 'warning'})
              this.loading = false
              return
            }

            let website_url = val
            if (!website_url.match(/https?:\/\//i)) {
              website_url = `http://${website_url}`
            }

            item.website = website_url
          }

          if (key === 'Email' && val) {
            item.email = val.toLowerCase().trim()
          }
        }

        if (item.email) {
          item.name = item.email
        } else if (item.first_name && item.website) {
          item.name = item.first_name + ' - ' + item.website
        } else if (item.website) {
          item.name = item.website
        } else if (item.first_name) {
          item.name = item.first_name
        } else {
          item.name = `${moment().format('HH:MM DD/MM/YY')} - ${parseInt(row_i)+1}`
        }

        items.push(item)
      }

      if (items.length === 0) {
        this.loading = false
        this.$swal({title: 'Add image', text: "Please add at least one image", icon: 'warning'})
        return
      }

      let proms = []
      for (let item of items) {
        let item_id = db.collection('item').doc().id
        proms.push(db.collection('image_template').doc(this.$route.params.id).collection('image').doc(item_id).set(item))
        item.id = item_id
      }

      await Promise.all(proms)

      let update = {updated: new Date()}
      update[`usage.${this.profile.id}.images`] = FieldValue.increment(items.length)
      await db.collection('team').doc(this.profile.team.id).collection('period').doc(this.profile.team.current_period.id).update(update)

      await db.collection('image_template').doc(this.$route.params.id).update({updated: new Date(), images_count: FieldValue.increment(items.length)})

      if (items.length === 1) {
        this.loading = false
        this.$router.push({name: 'image', params: {image: items[0].id, from_item: items[0]}})
      } else {
        await this.$swal({title: 'Images added', text: `${items.length} images have been added`, icon: 'success'})
        this.loading = false
        this.$router.push({name: 'image_template'})
      }
    }
  }
}
</script>

<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style>
.input-table {
    height: 280px;
    margin-bottom: 0px;
}
</style>
